import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const FormDialog: React.FC<FormDialogProps> = ({ open, onClose, children }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      id="form_dialog"
      data-test-id="form_dialog"
      aria-label="Form dialog"
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
        }}
        id="form_dialog_title"
        data-test-id="form_dialog_title"
        aria-label="Form dialog title"
      >
        Add Form
        <IconButton 
          onClick={onClose} 
          size="small"
          id="form_dialog_close_button"
          data-test-id="form_dialog_close_button"
          aria-label="Close form dialog"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent 
        sx={{ p: 3 }}
        id="form_dialog_content"
        data-test-id="form_dialog_content"
        aria-label="Form dialog content"
      >
        <Box 
          sx={{ py: 3, width: "100%" }}
          id="form_dialog_content_box"
          data-test-id="form_dialog_content_box"
          aria-label="Form dialog content container"
        >
          {children}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FormDialog;
